import React from 'react';
import { DocsPageShell } from './DocsLayout';
import { getSectionsByAudience } from '../../utils/docsContent';

const parentSections = getSectionsByAudience('parent');

const NAV_LINKS = [
  { to: '/docs/student', label: 'Student Guide' },
  { to: '/docs/teacher', label: 'Teacher Guide' },
];

export const DocsParent = () => (
  <DocsPageShell
    title="Parent & Visitor Guide"
    subtitle="Learn about Frankly Talking English — courses, the free level test, trial classes, and how to get in touch."
    sections={parentSections}
    navLinks={NAV_LINKS}
  />
);

export default DocsParent;
